import * as React from 'react'

import { RadioGroup as RadioGroupPrimitive } from 'radix-ui'

import { cn } from './cn'

export interface RadioGroupProps {
  value?: string
  defaultValue?: string
  onChange?: (event: { target: { value: string } }, value: string) => void
  name?: string
  row?: boolean
  className?: string
  children?: React.ReactNode
  'aria-label'?: string
  'aria-labelledby'?: string
}

export const RadioGroup = React.forwardRef<HTMLDivElement, RadioGroupProps>(
  (
    { value, defaultValue, onChange, name, row, className, children, ...props },
    ref,
  ) => (
    <RadioGroupPrimitive.Root
      ref={ref}
      value={value}
      defaultValue={defaultValue}
      name={name}
      onValueChange={(next) => onChange?.({ target: { value: next } }, next)}
      className={cn(
        'flex',
        row ? 'flex-row flex-wrap gap-x-4' : 'flex-col',
        className,
      )}
      {...props}
    >
      {children}
    </RadioGroupPrimitive.Root>
  ),
)
RadioGroup.displayName = 'RadioGroup'

export interface RadioProps {
  value?: string
  disabled?: boolean
  size?: 'small' | 'medium'
  className?: string
  id?: string
}

export const Radio = React.forwardRef<HTMLButtonElement, RadioProps>(
  ({ value = '', disabled, size = 'medium', className, id }, ref) => (
    <RadioGroupPrimitive.Item
      ref={ref}
      id={id}
      value={value}
      disabled={disabled}
      className={cn(
        'inline-flex shrink-0 cursor-pointer items-center justify-center rounded-full border-2 transition-colors',
        size === 'small' ? 'h-[18px] w-[18px]' : 'h-5 w-5',
        'border-text-secondary data-[state=checked]:border-primary',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50',
        'disabled:pointer-events-none disabled:opacity-40',
        className,
      )}
    >
      <RadioGroupPrimitive.Indicator className="block h-2.5 w-2.5 rounded-full bg-primary" />
    </RadioGroupPrimitive.Item>
  ),
)
Radio.displayName = 'Radio'
